<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
  
          <div class="modal-close">
            <span @click="$emit('close')">
              <slot name="modal-close">x</slot>
            </span>
          </div>
          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
          </div>
  
          <div class="modal-body">
            <slot name="body">
              default body
            </slot>
          </div>
  
          <div class="modal-footer">
            <div class="modal-default-button" @click="donate()">
              <slot name="bottm-button">
                Button
              </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  const axios = require('axios').default;

  export default {
    name: 'Modal',
    props:['variantid'],
    data() {
      return {  
      }
    },
    methods: {
      donate() {
        // add donation product
				const config = {
					method: 'post',
					url: '/cart/add.js',
					data: {
						id: this.variantid,
						quantity: 1
					},
				};
				axios(config)
				.then(() => window.location.reload())
				.catch(err => console.error(err))
      }
    },
    mounted() {
      console.log('mounted')
    }
  };
  </script>
  
  <style >
    .modal-mask {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 250;
      width: 100vw;
      height: 100vh;
      border: 2px red dashed;
      background: rgba(0,0,0, 0.25);
    }
    .modal-wrapper {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .modal-container {
      width: 340px;
      padding: 35px 20px;
      display: flex;
      flex-direction: column;
      background: #FFF;
    }
    .modal-header {
      margin-bottom: 15px;
    }
    .modal-close {
      position: relative;
      right: 0;
      text-align: right;
    }
    .modal-body {
      margin-bottom: 30px;
    }
    .modal-footer .modal-default-button {
      width: 100%;
      padding-block: 15px;
      background: #000;
      color: #FFF;
      text-align: center;
      border: none;
      cursor: pointer;
    }
    
  </style>
  